import Vue from 'vue'


  const VueVideoPlayer = require('vue-video-player/ssr')
  Vue.use(VueVideoPlayer)
